import React, { useEffect } from "react";

const BadgesPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Badges</h1>
      <p>Here are your badges.</p>
    </div>
  );
};

export default BadgesPage;
